class Controller {
  constructor($mdDialog, isApprove) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.isApprove = isApprove;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide({
      notes: this.notes,
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/approveContractDialog/approveContractDialog.controller.js